export default __webpack_public_path__ + "eeffb59c7a7c0718086d931d976ac1c5.png";